import React, { useId } from "react";
import PropTypes from "prop-types";

const paths = [
  "M4.676 14.6493C7.85919 12.7836 11.8912 12.7836 15.0744 14.6493C15.1752 14.7084 15.3007 14.7781 15.4436 14.8574C16.0762 15.2086 17.0481 15.7481 17.7135 16.3892C18.129 16.7896 18.5385 17.3303 18.6133 18.0037C18.6934 18.7252 18.3711 19.3911 17.7548 19.9691C16.7047 20.9539 15.4368 21.75 13.7944 21.75H5.95596C4.31362 21.75 3.0457 20.9538 1.99562 19.9691C1.3793 19.3911 1.05695 18.7252 1.13707 18.0037C1.21184 17.3303 1.6214 16.7896 2.03689 16.3892C2.70228 15.7481 3.67419 15.2086 4.30683 14.8574C4.44965 14.7781 4.5752 14.7084 4.676 14.6493Z",
  "M5.12519 7C5.12519 4.37665 7.25184 2.25 9.87519 2.25C12.4985 2.25 14.6252 4.37665 14.6252 7C14.6252 9.62335 12.4985 11.75 9.87519 11.75C7.25184 11.75 5.12519 9.62335 5.12519 7Z",
  "M19.375 3C19.9273 3 20.375 3.44772 20.375 4V5.5H21.875C22.4273 5.5 22.875 5.94772 22.875 6.5C22.875 7.05228 22.4273 7.5 21.875 7.5H20.375V9C20.375 9.55228 19.9273 10 19.375 10C18.8227 10 18.375 9.55228 18.375 9V7.5H16.875C16.3227 7.5 15.875 7.05228 15.875 6.5C15.875 5.94771 16.3227 5.5 16.875 5.5L18.375 5.5V4C18.375 3.44772 18.8227 3 19.375 3Z",
];

const gradients = [
  { x1: "17.4138", y1: "6.25444", x2: "2.44987", y2: "20.0885" },
  { x1: "17.4138", y1: "6.25444", x2: "2.44987", y2: "20.0885" },
  { x1: "22.3904", y1: "4.43749", x2: "17.0045", y2: "9.9856" },
];

const UserPlusIcon = ({
  selected,
  width,
  height,
  className,
  ...props
}) => {
  const id = useId().replace(/:/g, "");
  const isActive = selected;
  const gradientIds = paths.map((_, index) => `user-plus-gradient-${index}-${id}`);

  return (
    <svg
      width={width || 24}
      height={height || 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <g opacity={isActive ? undefined : "0.5"}>
        {paths.map((pathD, index) => (
          <path
            key={pathD}
            d={pathD}
            fillRule={index === 2 ? "evenodd" : undefined}
            clipRule={index === 2 ? "evenodd" : undefined}
            fill={`url(#${gradientIds[index]})`}
          />
        ))}
      </g>
      <defs>
        {gradientIds.map((gradientId, index) => (
          <linearGradient
            key={gradientId}
            id={gradientId}
            {...gradients[index]}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D946EF" />
            <stop offset="1" stopColor="#67E8F9" />
          </linearGradient>
        ))}
      </defs>
    </svg>
  );
};

UserPlusIcon.propTypes = {
  selected: PropTypes.bool,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
};

UserPlusIcon.defaultProps = {
  selected: false,
  width: undefined,
  height: undefined,
  className: "",
};

export default UserPlusIcon;
